module.exports = __webpack_public_path__ + "img/blue-penguin.da97c2dd.svg";